import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { track } from '../lib/analytics';

const classify = (a) => {
  const href = a.getAttribute('href') || '';
  const path = a.pathname || '';
  if (href.startsWith('https://wa.me') || href.includes('whatsapp')) return ['contact_whatsapp', { href }];
  if (href.startsWith('tel:')) return ['contact_phone', { href }];
  if (href.startsWith('mailto:')) return ['contact_email', { href }];
  if (path === '/buchen') return ['booking_click', {}];
  if (path === '/quiz') return ['quiz_start_click', {}];
  if (path === '/portal') return ['portal_click', {}];
  if (href.includes('instagram.com')) return ['social_click', { network: 'instagram' }];
  return null;
};

export default function AnalyticsListener() {
  const { pathname } = useLocation();

  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest?.('a[href], button[data-track]');
      if (!a) return;
      if (a.dataset.track) { track(a.dataset.track, { label: a.textContent?.trim().slice(0, 60), page: pathname }); return; }
      const hit = classify(a);
      if (hit) track(hit[0], { ...hit[1], label: a.textContent?.trim().slice(0, 60), page: pathname });
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, [pathname]);

  useEffect(() => {
    if (pathname === '/buchen') track('begin_booking', { page: pathname });
  }, [pathname]);

  return null;
}
